function createQueue() {
  var queue = new Array();

  function add(fn) {
    queue.push(fn);
  }

  function clear() {
    queue.length = 0;
  }

  function flush() {
    queue.forEach(function (fn) {
      return fn();
    });
    clear();
  }

  add.clear = clear;
  add.flush = flush;
  return add;
}

export { createQueue };
